import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#E5E5E5",
    iconColor: "#AD4970;",
    textColor: "#000000;",
    hoverBg: "linear-gradient(180deg, #E93848 0%, #773562 80.73%)",
    activeBg: "linear-gradient(180deg, #E93848 0%, #773562 80.73%)" 
  },
  topbar: {
    bg: "#E93848",
    color: "#000"
  },
  gradient: {
    bg: "#E93848",
    shadow: "#773562"
  },
  mainBg: '#FFFFF'
};

export default colorConfigs;